import { createAsyncThunk } from '@reduxjs/toolkit'

import { ServiceConfig } from '../services/config'
import { APIReject, APIError, get, put, post, remove } from '../services/crud'

import type { CustomFieldDTO, CustomFieldInput } from '@sales-center/common'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.customFields.customFields}`

export const getCustomFieldById = createAsyncThunk<
  CustomFieldDTO,
  number,
  { rejectValue: APIReject }
>('customFields/get', async (id, thunkApi) => {
  const response = await get(`${baseUrl}/${id}`)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const getAllCustomFields = createAsyncThunk<
  CustomFieldDTO[],
  void,
  { rejectValue: APIError }
>('customFields/getAll', async (_, thunkApi) => {
  const response = await get(baseUrl)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const addCustomField = createAsyncThunk<
  CustomFieldDTO,
  CustomFieldInput,
  { rejectValue: APIReject }
>('customFields/add', async (field, thunkApi) => {
  const response = await post(baseUrl, field)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const updateCustomField = createAsyncThunk<
  CustomFieldDTO,
  CustomFieldInput,
  { rejectValue: APIReject }
>('customFields/update', async (field, thunkApi) => {
  const response = await put(baseUrl, field)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const removeCustomField = createAsyncThunk<
  void,
  number,
  { rejectValue: APIReject }
>('customFields/remove', async (id, thunkApi) => {
  const response = await remove(`${baseUrl}/${id}`)
  if (!response.ok) return thunkApi.rejectWithValue(await response.json())
})

export const isFieldInUse = createAsyncThunk<
  number,
  number,
  { rejectValue: APIReject }
>('customFields/inUse', async (id, thunkApi) => {
  const response = await get(`${baseUrl}/${id}/isInUse`)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const isOptionInUse = createAsyncThunk<
  number,
  { id: string; optionId: string },
  { rejectValue: APIReject }
>('customFields/optInUse', async ({ id, optionId }, thunkApi) => {
  const response = await get(`${baseUrl}/${id}/isOptionInUse/${optionId}`)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})
